<div echarts [options]="option" class="chart"></div>